import { setCssVar } from 'quasar';
import tailwindCss from '@/assets/stylesheets/tailwindcss-v4.css?raw';

// Dynamically read CSS variables from tailwindcss-v4.css and set them for Quasar
function loadCssVariables() {
  try {
    const cssContent = tailwindCss;

    // Parse CSS variables that start with --color
    const colorVariables = cssContent.match(/--color-[a-z0-9-]+:\s*[^;]+;/gi);
    if (colorVariables) {
      colorVariables.forEach((variable) => {
        const match = variable.match(/--color-([a-z0-9-]+):\s*([^;]+);/);
        if (match) {
          const [, name, value] = match;
          setCssVar(name.trim(), value.trim());
        }
      });
    }
  } catch (error) {
    console.error('Failed to load CSS variables:', error);
  }
}

// Load CSS variables on boot
loadCssVariables();
